import { useState } from "react";
const useCrop = ()=>{
    const [crop, setCrop] = useState();
    const [completedCrop, setCompletedCrop] = useState();
    const handleImageLoad = (..._)=>{};
    return {
        crop,
        completedCrop,
        setCrop,
        setCompletedCrop,
        handleImageLoad
    };
};
export { useCrop };
